import { render, staticRenderFns } from "./PanelListItem.vue?vue&type=template&id=5971e909&scoped=true"
import script from "./PanelListItem.vue?vue&type=script&lang=js"
export * from "./PanelListItem.vue?vue&type=script&lang=js"
import style0 from "./PanelListItem.vue?vue&type=style&index=0&id=5971e909&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5971e909",
  null
  
)

export default component.exports